import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

function QuickEntry(): JSX.Element {
    const {
        base_config: { quick_entry }
    } = useSelector(
        ({ IndexReducer }) => ({
            base_config: IndexReducer.base_config
        }),
        shallowEqual
    );
    return (
        <div className="im-quick-entry">
            <div className="quick-title">快捷入口</div>
            <ul>
                {quick_entry?.map((item, index) => (
                    <li key={`quick${index + 1}`}>
                        <a target="_blank" rel="noreferrer" href={item.url}>
                            <div className="quick-icon">
                                <img src={item.icon} alt={item.name} />
                            </div>
                            <div className="quick-label">{item.name}</div>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default QuickEntry;
